import React, { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../firebaseConfig";

const AdminStats = () => {
  const [abonamenteCount, setAbonamenteCount] = useState(0);
  const [abonamenteCuPlan, setAbonamenteCuPlan] = useState(0);
  const [abonamenteFaraPlan, setAbonamenteFaraPlan] = useState(0);
  const [inscrieriCount, setInscrieriCount] = useState(0);
  const [traseeStats, setTraseeStats] = useState({});

  useEffect(() => {
    const unsubAbonamente = onSnapshot(
      collection(db, "abonamente"),
      (snapshot) => {
        let cuPlan = 0;
        let faraPlan = 0;

        snapshot.docs.forEach((doc) => {
          const data = doc.data();
          const plan = (data.planAlimentar || "").toString().toLowerCase();
          if (plan.includes("cu plan")) {
            cuPlan++;
          } else if (plan.includes("fara")) {
            faraPlan++;
          } else {
            faraPlan++;
          }
        });

        setAbonamenteCount(snapshot.size);
        setAbonamenteCuPlan(cuPlan);
        setAbonamenteFaraPlan(faraPlan);
      }
    );

    const unsubInscrieri = onSnapshot(
      collection(db, "inscrieri_traseu"),
      (snapshot) => {
        let total = 0;
        const tipuri = {};

        snapshot.docs.forEach((doc) => {
          const data = doc.data();
          const tip = data.tipTraseu?.trim().toUpperCase() || "NECUNOSCUT";
          tipuri[tip] = (tipuri[tip] || 0) + 1;
          total++;
        });

        setInscrieriCount(total);
        setTraseeStats(tipuri);
      }
    );

    return () => {
      unsubAbonamente();
      unsubInscrieri();
    };
  }, []);

  const maiCount = traseeStats.MAI || 0;
  const mapnCount = traseeStats.MAPN || 0;
  const isuCount = traseeStats.ISU || 0;
  const anpCount = traseeStats.ANP || 0;

  return (
    <div className="admin-stats-card admin-statistici admin-stats-compact admin-stats-full">
      <h3 className="admin-stats-title">
        <span className="admin-stats-icon">📊</span>
        Statistici generale
      </h3>

      <div className="admin-stats-circles">
        <div className="admin-stat-circle">
          <p className="stat-label">Înscrieri totale</p>
          <p className="stat-value">{inscrieriCount}</p>
        </div>

        <div className="admin-stat-circle">
          <p className="stat-label">MAPN</p>
          <p className="stat-value">{mapnCount}</p>
        </div>

        <div className="admin-stat-circle">
          <p className="stat-label">MAI</p>
          <p className="stat-value">{maiCount}</p>
        </div>

        <div className="admin-stat-circle">
          <p className="stat-label">ISU</p>
          <p className="stat-value">{isuCount}</p>
        </div>

        <div className="admin-stat-circle">
          <p className="stat-label">ANP</p>
          <p className="stat-value">{anpCount}</p>
        </div>

        <div className="admin-stat-circle">
          <p className="stat-label">Abonamente</p>
          <p className="stat-value">{abonamenteCount}</p>
        </div>

        <div className="admin-stat-circle">
          <p className="stat-label">Abonamente cu plan</p>
          <p className="stat-value">{abonamenteCuPlan}</p>
        </div>

        <div className="admin-stat-circle">
          <p className="stat-label">Abonamente fara plan</p>
          <p className="stat-value">{abonamenteFaraPlan}</p>
        </div>
      </div>
    </div>
  );
};

export default AdminStats;
